module.exports = __webpack_public_path__ + "img/banner2_1.7f8309e3.png";